// Order Now button. Moves the personalize inputs to become real children of Craft's own
// add-to-cart form on page load, so native FormData(form) picks them up automatically —
// no manual field reconstruction, no reliance on the form="..." attribute (which Shopify
// silently strips from content saved in custom_liquid blocks).
(function () {
  function moveFieldsIntoForm() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var block = document.querySelector('.cc-personalize-block');
    if (form && block && !form.contains(block)) {
      form.appendChild(block);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveFieldsIntoForm);
  } else {
    moveFieldsIntoForm();
  }

  function findEmptyRequiredField() {
    var fields = document.querySelectorAll('.cc-personalize-input[required]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var isEmpty = f.type === 'file' ? f.files.length === 0 : !f.value.trim();
      if (isEmpty) return f;
    }
    return null;
  }

  function showWarning(field) {
    field.classList.add('cc-field-error');
    field.focus();
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var block = field.closest('.cc-personalize-block');
    if (!block) return;
    var msg = block.querySelector('.cc-field-warning');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cc-field-warning';
      msg.textContent = 'Please fill this in before you can place your order.';
      block.appendChild(msg);
    }
    msg.style.display = 'block';

    var clearWarning = function () {
      msg.style.display = 'none';
      field.classList.remove('cc-field-error');
      field.removeEventListener('input', clearWarning);
      field.removeEventListener('change', clearWarning);
    };
    field.addEventListener('input', clearWarning);
    field.addEventListener('change', clearWarning);
  }

  function showButtonError(btn, text) {
    var wrap = btn.closest('.cc-cta-block');
    if (!wrap) return;
    var msg = wrap.querySelector('.cc-cta-error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cc-cta-error';
      msg.style.cssText = 'color:#8C1F2B;font-size:12px;font-weight:700;margin:0;padding:8px 10px;background:#FBEAEA;border-left:3px solid #8C1F2B;';
      wrap.insertBefore(msg, btn.nextSibling);
    }
    msg.textContent = text;
    msg.style.display = 'block';
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var emptyField = findEmptyRequiredField();
      if (emptyField) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showWarning(emptyField);
      }
    },
    true
  );

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cc-btn-primary');
    if (!btn) return;
    e.preventDefault();

    var emptyField = findEmptyRequiredField();
    if (emptyField) { showWarning(emptyField); return; }

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) { showButtonError(btn, 'Could not find the order form. Please refresh and try again.'); return; }

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Processing...';

    var formData = new FormData(form);
    var cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    fetch(cartAddUrl, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (data) {
            throw new Error((data && (data.description || data.message)) || ('HTTP ' + r.status));
          });
        }
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = originalText;
        showButtonError(btn, err && err.message ? err.message : 'Something went wrong. Please try again or use Add to Cart below.');
      });
  });
})();
